import { ResetPasswordView } from "./resetPasswordView";
    
import loginTemplateFrame from "./templateFrame.jst";
import templateBody from "./newUser.jst";

export const NewUserView = ResetPasswordView.extend({
    template: (data) => loginTemplateFrame({
        partial: templateBody,
        ...data
    })
});
